/**
 * FAQ — 자주 묻는 질문 (아코디언)
 *
 * preview/index.html 의 .faq 1:1 매칭
 *  - 한 번에 하나만 열림 (다른 항목은 자동으로 닫힘)
 *  - max-height 트랜지션으로 펼침/접힘 애니메이션
 *
 * 데이터: FAQS (config/constants.ts)
 */
import { useRef, useState } from 'react';
import { FAQS } from '@/config/constants';

export function FAQ() {
  const [openIdx, setOpenIdx] = useState<number | null>(null);
  // 각 답변의 실제 높이 측정용 ref 배열
  const answerRefs = useRef<Array<HTMLDivElement | null>>([]);

  const toggle = (idx: number) => {
    setOpenIdx((cur) => (cur === idx ? null : idx));
  };

  return (
    <section className="faq" id="faq">
      <div className="section-head">
        <span className="section-tag">FAQ</span>
        <h2 className="section-title"><span className="accent">자주 묻는</span> 질문</h2>
        <p className="section-sub">상담 전에 자주 받는 질문을 정리했습니다.</p>
      </div>

      <div className="faq-inner">
        {FAQS.map((item, idx) => {
          const isOpen = openIdx === idx;
          // 열렸을 때 실제 콘텐츠 높이로 max-height 지정 (트랜지션 위해)
          const maxH = isOpen
            ? (answerRefs.current[idx]?.scrollHeight ?? 0) + 'px'
            : '0px';

          return (
            <div key={idx} className={`faq-item${isOpen ? ' open' : ''}`}>
              <button
                type="button"
                className="faq-question"
                aria-expanded={isOpen}
                onClick={() => toggle(idx)}
              >
                <span className="faq-q-prefix">Q</span>
                <span className="faq-q-text">{item.q}</span>
                <svg
                  className="faq-icon"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="2.2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                >
                  <polyline points="6 9 12 15 18 9" />
                </svg>
              </button>
              <div className="faq-answer" style={{ maxHeight: maxH }}>
                <div
                  className="faq-answer-inner"
                  ref={(el) => {
                    answerRefs.current[idx] = el;
                  }}
                >
                  {item.a}
                </div>
              </div>
            </div>
          );
        })}
      </div>
    </section>
  );
}
